import { toggleAttribute, slideToggle } from '../helper';

const ACCORDION_ITEM = document.querySelectorAll('.accordion .accordion__item');


const toggleAccordion = (el) => {
	const btn = el.querySelector('.accordion__header');
	const panel = el.querySelector('.accordion__panel');

	if (panel) {
		el.classList.toggle('open');
		slideToggle(panel, btn);
	}
}


const MAGAZINE_ACCORDION = document.querySelector('.ce--vd_magazines .accordion');

if (MAGAZINE_ACCORDION) {
	const MAGAZINE_FIRST_EL = MAGAZINE_ACCORDION.querySelector('.accordion__item');
	toggleAccordion(MAGAZINE_FIRST_EL);
}


// EVENTS
ACCORDION_ITEM.forEach((item) => {
	const btn = item.querySelector('.accordion__header');
	btn.addEventListener('click', () => toggleAccordion(item));
});



